import aiLogger from './aiLogger';

// Debug mode utility
export const enableDebugMode = () => {
  aiLogger.setDebugMode(true);
  console.log('🔧 Debug mode enabled - you will now see detailed logs');
};

export const disableDebugMode = () => {
  aiLogger.setDebugMode(false);
  console.log('🔧 Debug mode disabled - logs are now minimal');
};

// Check URL parameter for debug mode
export const checkDebugMode = () => {
  const urlParams = new URLSearchParams(window.location.search);
  const debugMode = urlParams.get('debug');
  
  if (debugMode === 'true') {
    enableDebugMode();
  } else if (debugMode === 'false') {
    disableDebugMode();
  }
  
  return aiLogger.debugMode;
};

// Add to window for easy access in browser console
if (typeof window !== 'undefined') {
  window.enableDebugMode = enableDebugMode;
  window.disableDebugMode = disableDebugMode;
  window.checkDebugMode = checkDebugMode;
  window.aiLogger = aiLogger;
} 